// extracted by mini-css-extract-plugin
module.exports = {"select":"_36dPB3e_oOv40Y-6Lxv1Kf"};